export const SearchQuery = `
query ListSpaces($query: String!, $siteAri: String!, $entityAti: String!, $confluenceSpaces: [String!], $projectTypes: [SearchProjectType!]) {
	search {
		search(
			query: $query
			filters: {
				entities: [$entityAti],
				locations: [$siteAri],
				confluenceFilters: {
					spacesFilter: $confluenceSpaces
				},
        jiraFilters: {
          projectFilter: {
            projectTypes: $projectTypes
          }
        }
			}
			experience: "rovo-chat"
		) {
			edges {
				node {
					ari: id
					displayName: title
					iconUrl
					url
					... on SearchConfluenceSpace {
						spaceKey: key
					}
				}
			}
		}
	}
}
`;

export const JiraProjectsQuery = `
query GetProjects($aris: [ID!]!) {
  jira {
    jiraProjects(
      ids: $aris
    ) {
      ari: id
      displayName: name
      iconUrl: avatar {
        small
      }
			url: webUrl
    }
  }
}
`;

export const ConfluencePagesQuery = `
query GetPages($aris: [ID!]!) {
  confluence {
    pages(
      ids: $aris
    ) {
      ari: id
      displayName: title
			links {
        base
        webUi
      }
    }
  }
}
`;

export const GetSpacesQuery = `
query GetSpaces($aris: [ID!]!) {
  confluence {
    spaces(
      ids: $aris
    ) {
      ari: id
      displayName: name
      iconUrl: icon {
        path
      }
			spaceKey: key
			links {
        base
        webUi
      }
    }
  }
}
`;

/**
 * Resolve a single help center by ARI.
 * Used by getEntitiesByAris for help-center resource type.
 */
export const GetHelpCenterByIdQuery = `
query GetHelpCenterById($cloudId: ID!, $helpCenterAri: ID!) {
  helpCenter(cloudId: $cloudId) {
    helpCenterById(helpCenterAri: $helpCenterAri) @optIn(to: "HelpCenterAggBeta") {
      __typename
      ... on Node {
        ... on HelpCenter {
          name {
            default
          }
        }
      }
    }
  }
}
`;
